// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3JfZS","rootCenter":"LoadMoreObserver_rootCenter__BGOOu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__21sob"};